import {
  apiService,
  VoucherExchange,
  GetVoucherExchangesResponse,
  SwitchVoucherPartnerRequest,
  SwitchVoucherPartnerResponse,
} from "./api";

export class VoucherExchangesService {
  private static instance: VoucherExchangesService;

  private constructor() {}

  public static getInstance(): VoucherExchangesService {
    if (!VoucherExchangesService.instance) {
      VoucherExchangesService.instance = new VoucherExchangesService();
    }
    return VoucherExchangesService.instance;
  }

  public async getVoucherExchanges(params?: {
    phone?: string;
    partner_id?: string;
    campaign_id?: string;
  }): Promise<GetVoucherExchangesResponse> {
    return apiService.getVoucherExchanges(params);
  }

  public async switchVoucherPartner(
    exchangeId: string,
    data: SwitchVoucherPartnerRequest
  ): Promise<SwitchVoucherPartnerResponse> {
    return apiService.switchVoucherPartner(exchangeId, data);
  }
}

export const voucherExchangesService = VoucherExchangesService.getInstance();

export type { VoucherExchange };
